import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons/faClock';
// import { faTrophy } from '@fortawesome/free-solid-svg-icons/faTrophy';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import EventRegistrationButton from 'buyside/components/presentation/EventPage/EventRegistrationButton/eventRegistrationButton';
import EventRegistrationButtonSubtitle from 'buyside/components/presentation/EventPage/EventRegistrationButtonSubtitle/eventRegistrationButtonSubtitle';
// import Link from 'buyside/components/presentation/Link/link';
import FadeInContainer from 'buyside/components/presentation/FadeInContainer/fadeInContainer';
import PublicRegistrationForm from 'buyside/components/presentation/EventPage/PublicRegistrationForm/publicRegistrationForm';

// import { ideaUrl } from 'buyside/util/urlHelper';

// import { useTopStockWinnersQuery } from 'interfaces/graphql-typings';

import styles from './eventAgendaStyles.scss';

const agenda = [
  {
    time: '12:00 PM – 1:00 PM',
    title: 'Registration & Networking'
  },
  {
    time: '1:00 PM – 1:45 PM',
    title: 'Venture Capital Panel Discussion',
    guests: [
      'Jordan Fliegel – Techstars',
      'Jason Shuman – Primary VC',
      'Dorothy Chang – Flybridge',
      'Semyon Dukach - One Way Ventures',
      'Sarah Hoffman - AlphaSense'
    ]
  },
  {
    time: '1:45 PM – 2:00 PM',
    title: 'Break'
  },
  {
    time: '2:00 PM – 3:00 PM',
    title: 'Stock Pitch Presentations',
    guests: [
      'Scott Miller - Greenhaven Road Capital',
      'Nitin Sacheti - Papyrus Capital',
      'Edward Robson - 2717 Capital',
      'Eric DeLarmater - Half Moon Capital',
      'Raj Shah - Stoic Point Capital'
    ]
  },
  {
    time: '3:00 PM – 4:00 PM',
    title: 'Networking & Live Voting on Stock Pitches'
  },
  {
    time: '4:00 PM – 5:00 PM',
    title: 'Keynote Discussion',
    guests: ['Dan Rasmussen – Verdad Advisers']
  },
  {
    time: '5:00 PM – 6:00 PM',
    title: 'Closing Networking, Food & Drinks'
  }
];

const EventAgenda: React.FC<{ isLoggedIn: boolean }> = ({ isLoggedIn }) => {
  // const { data, error } = useTopStockWinnersQuery();

  // if (error) throw error;

  // const winningIdeas = data?.topStockWinners;

  return (
    <div id="agenda" className={styles.agendaContainer}>
      <div className={styles.heading}>
        Agenda
        {/* <div className={styles.subtitle}>Final agenda to be confirmed in weeks ahead.</div> */}
      </div>
      <div className={styles.agenda}>
        {agenda.map(slot => {
          // const winningIdea = winningIdeas?.find(winningIdea => winningIdea.id === slot.ideaId);
          const guestSpeakers = slot.guests; // winningIdea?.user?.displayName || slot.guests;

          return (
            <FadeInContainer className={styles.agendaSlot} key={slot.time}>
              <div className={styles.agendaSlotLeft}>
                <div className={styles.agendaSlotTime}>
                  <FontAwesomeIcon icon={faClock} />
                  {slot.time}
                </div>
                <div className={styles.agendaSlotTitle}>{slot.title}</div>
                {/* <div className={styles.agendaSlotCategory}>{slot.category}</div> */}
              </div>
              {guestSpeakers && (
                <div className={styles.agendaSlotRight}>
                  {guestSpeakers.map((speaker, idx) => (
                    <div key={idx}>
                      <FontAwesomeIcon icon={faUser} />
                      {speaker}
                    </div>
                  ))}
                  {/* <div>
                    {winningIdea?.entityName && (
                      <>
                        <FontAwesomeIcon className={styles.trophyIcon} icon={faTrophy} />
                        <Link to={ideaUrl(winningIdea.id)} target="_blank">
                          {winningIdea.entityName}
                        </Link>
                      </>
                    )}
                  </div> */}
                </div>
              )}
            </FadeInContainer>
          );
        })}
      </div>
      {isLoggedIn ? <EventRegistrationButton /> : <PublicRegistrationForm />}

      <EventRegistrationButtonSubtitle />
    </div>
  );
};

export default EventAgenda;
